@import 'styles/mixins';
@import 'styles/variables';

.banner {
  @include shadow;

  border-radius: 8px;
  color: $almanac-black;
  padding: map-get($spacers, 3);

  &.info {
    background: $blue-5;
  }
}
